export default __webpack_public_path__ + "static/media/tiktok-logo.e0587519.svg";